<template>
  <div id="app">
    <CalligraphyCanvas />
  </div>
</template>

<script>
import CalligraphyCanvas from './components/CalligraphyCanvas.vue'

export default {
  name: 'App',
  components: {
    CalligraphyCanvas
  }
}
</script>

<style>
/* 导入楷体字体 */
@font-face {
  font-family: 'KaiTi';
  src: url('~@/assets/fonts/KaiTi.TTF') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f8f9fa;
  color: #333;
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

#app {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
</style>
